// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainColumn {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 25px;
    min-height: calc(100vh - 92px);
    /* padding-bottom: 110px; */
    padding-bottom: 90px;
}

.mainHeader {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 10px;
}

.mainHeaderSearchBlock {
    width: 100%;
    padding: 25px 15px 15px 15px;
    background: #FF6B00;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-radius: 0 0 24px 24px;
}

.mainHeaderSearchInput {
    width: 100%;
    height: 40px;
    border-radius: 32px;
    background: #FFF4D9;
    border: none;
    padding: 8px 17px;
    font-size: 20px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    color: #8E3B00;
    position: relative;
    z-index: 0;
    font-family: Alegreya Sans;
}

.mainHeaderSearchInput::placeholder {
    font-size: 20px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    color: #B8B8B8;
    font-family: Alegreya Sans;
}

.mainHeaderSearchInput:focus {
    outline: none;
}

.mainHeaderSearchIcon {
    position: absolute;
    z-index: 1;
    right: 32px;
    top: 35px;
}

.mainEmptyImage {
    max-height: 45%;
    /* width: 182.76px;
    height: 328.82px; */
}

.mainHeaderSortColumn {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: left;
    justify-content: left;
    padding: 0 16px;
    min-height: 44px;
}
.mainHeaderSortRow {
    display: flex;
    flex-direction: row;
    gap: 12px;
    align-items: left;
    justify-content: space-between;
}
.mainHeaderSortHr {
    border: none;
    border-top: 1px solid #BB8D6C
}

.mainHeaderSortButton {
    background: none;
    border: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 11px;
    width: max-content;
    padding: 7px 8px 5px 8px;
}

.mainHeaderSortButtonText {
    font-family: "Alegreya Sans", sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 19.2px;
    text-align: left;
    color: #8E3B00;
}

.mainEmptyColumn {
    display: flex;
    flex-direction: column;
    gap: 80px;
    width: 100%;
    height: calc(100vh - 250px);
    align-items: center;
    justify-content: flex-end;
}

.mainHeaderSortBlock {
    background: #FFF4D9;
    border: 3px solid #FFE8AE;    
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 177px;
    z-index: 150;
    border-radius: 8px;
    position: absolute;
    margin-top: -43px;
}


.mainHeaderFilterBlock {
    background: #FFF4D9;
    border: 3px solid #FFE8AE;    
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 177px;
    border-radius: 8px;
    position: absolute;
    right: 0px;
    z-index: 150;
    margin-top: -43px;
}

.mainHeaderSortBlockButton {
    background: none;
    border: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: left;
    gap: 11px;
    width: 100%;
    padding: 7px 5px 5px 5px;
    background: #FFE8AE;
    border-radius: 7px;
}

.mainHeaderSortBlockItem {
    display: flex;
    flex-direction: row;
    width: calc(100% - 16px);
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #BB8D6C;
    padding: 0 0 8px 0;
}

.mainHeaderFilterBlockItem {
    display: flex;
    flex-direction: row;
    width: calc(100% - 16px);
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #BB8D6C;
    padding: 0 0 8px 0;
}

.noBorderBottom {
    border-bottom: none;
}

.mainHeaderSortBlockItemText {
    font-family: Alegreya Sans;
    font-size: 16px;
    font-weight: 700;
    line-height: 19.2px;
    text-align: left;
    color: #8E3B00;
}

.mainHeaderSortColumnTop {
    padding-top: 43px;
}

.adCardButton {
    background: #FF6B00;
    border-radius: 16px;
    border-radius: 16px;
    width: 100%;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 11px 30px;
    font-family: Alegreya Sans;
    font-size: 16px;
    font-weight: 700;
    line-height: 12.8px;
    text-align: left;
    color: #FFE4D0;
}

.adsList {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    width: 100%;
    gap: 8px;
    padding: 0 16px 20px 16px;
}

@media (min-width: 480px) {
    .adsList {
        gap: 16px;
    }
}

@media (min-width: 640px) {
    .adsList {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (min-width: 960px) {
    .adsList {
        grid-template-columns: repeat(4, 1fr);
    }
}

@media (min-width: 1280px) {
    .adsList {
        grid-template-columns: repeat(5, 1fr);
    }
}

@media (min-width: 1536px) {
    .adsList {
        grid-template-columns: repeat(6, 1fr);
    }
}

@media (min-width: 1700px) {
    .adsList {
        grid-template-columns: repeat(7, 1fr);
    }
}

@media (min-width: 1920px) {
    .adsList {
        grid-template-columns: repeat(8, 1fr);
    }
}

@media (min-width: 2560px) {
    .adsList {
        grid-template-columns: repeat(9, 1fr);
    }
}

`, "",{"version":3,"sources":["webpack://./src/components/Main/Main.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,SAAS;IACT,8BAA8B;IAC9B,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;IACX,4BAA4B;IAC5B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,SAAS;AACb;;AAEA;IACI,eAAe;IACf;uBACmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,8BAA8B;AAClC;AACA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,2BAA2B;IAC3B,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;;AAGA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,SAAS;IACT,WAAW;IACX,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,WAAW;IACX,QAAQ;IACR,yBAAyB;AAC7B;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ","sourcesContent":[".mainColumn {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 25px;\n    min-height: calc(100vh - 92px);\n    /* padding-bottom: 110px; */\n    padding-bottom: 90px;\n}\n\n.mainHeader {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 10px;\n}\n\n.mainHeaderSearchBlock {\n    width: 100%;\n    padding: 25px 15px 15px 15px;\n    background: #FF6B00;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    border-radius: 0 0 24px 24px;\n}\n\n.mainHeaderSearchInput {\n    width: 100%;\n    height: 40px;\n    border-radius: 32px;\n    background: #FFF4D9;\n    border: none;\n    padding: 8px 17px;\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 24px;\n    text-align: left;\n    color: #8E3B00;\n    position: relative;\n    z-index: 0;\n    font-family: Alegreya Sans;\n}\n\n.mainHeaderSearchInput::placeholder {\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 24px;\n    text-align: left;\n    color: #B8B8B8;\n    font-family: Alegreya Sans;\n}\n\n.mainHeaderSearchInput:focus {\n    outline: none;\n}\n\n.mainHeaderSearchIcon {\n    position: absolute;\n    z-index: 1;\n    right: 32px;\n    top: 35px;\n}\n\n.mainEmptyImage {\n    max-height: 45%;\n    /* width: 182.76px;\n    height: 328.82px; */\n}\n\n.mainHeaderSortColumn {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    align-items: left;\n    justify-content: left;\n    padding: 0 16px;\n    min-height: 44px;\n}\n.mainHeaderSortRow {\n    display: flex;\n    flex-direction: row;\n    gap: 12px;\n    align-items: left;\n    justify-content: space-between;\n}\n.mainHeaderSortHr {\n    border: none;\n    border-top: 1px solid #BB8D6C\n}\n\n.mainHeaderSortButton {\n    background: none;\n    border: none;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: 11px;\n    width: max-content;\n    padding: 7px 8px 5px 8px;\n}\n\n.mainHeaderSortButtonText {\n    font-family: \"Alegreya Sans\", sans-serif;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 19.2px;\n    text-align: left;\n    color: #8E3B00;\n}\n\n.mainEmptyColumn {\n    display: flex;\n    flex-direction: column;\n    gap: 80px;\n    width: 100%;\n    height: calc(100vh - 250px);\n    align-items: center;\n    justify-content: flex-end;\n}\n\n.mainHeaderSortBlock {\n    background: #FFF4D9;\n    border: 3px solid #FFE8AE;    \n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    width: 177px;\n    z-index: 150;\n    border-radius: 8px;\n    position: absolute;\n    margin-top: -43px;\n}\n\n\n.mainHeaderFilterBlock {\n    background: #FFF4D9;\n    border: 3px solid #FFE8AE;    \n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    width: 177px;\n    border-radius: 8px;\n    position: absolute;\n    right: 0px;\n    z-index: 150;\n    margin-top: -43px;\n}\n\n.mainHeaderSortBlockButton {\n    background: none;\n    border: none;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: left;\n    gap: 11px;\n    width: 100%;\n    padding: 7px 5px 5px 5px;\n    background: #FFE8AE;\n    border-radius: 7px;\n}\n\n.mainHeaderSortBlockItem {\n    display: flex;\n    flex-direction: row;\n    width: calc(100% - 16px);\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid #BB8D6C;\n    padding: 0 0 8px 0;\n}\n\n.mainHeaderFilterBlockItem {\n    display: flex;\n    flex-direction: row;\n    width: calc(100% - 16px);\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid #BB8D6C;\n    padding: 0 0 8px 0;\n}\n\n.noBorderBottom {\n    border-bottom: none;\n}\n\n.mainHeaderSortBlockItemText {\n    font-family: Alegreya Sans;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 19.2px;\n    text-align: left;\n    color: #8E3B00;\n}\n\n.mainHeaderSortColumnTop {\n    padding-top: 43px;\n}\n\n.adCardButton {\n    background: #FF6B00;\n    border-radius: 16px;\n    border-radius: 16px;\n    width: 100%;\n    border: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 11px 30px;\n    font-family: Alegreya Sans;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 12.8px;\n    text-align: left;\n    color: #FFE4D0;\n}\n\n.adsList {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    width: 100%;\n    gap: 8px;\n    padding: 0 16px 20px 16px;\n}\n\n@media (min-width: 480px) {\n    .adsList {\n        gap: 16px;\n    }\n}\n\n@media (min-width: 640px) {\n    .adsList {\n        grid-template-columns: repeat(3, 1fr);\n    }\n}\n\n@media (min-width: 960px) {\n    .adsList {\n        grid-template-columns: repeat(4, 1fr);\n    }\n}\n\n@media (min-width: 1280px) {\n    .adsList {\n        grid-template-columns: repeat(5, 1fr);\n    }\n}\n\n@media (min-width: 1536px) {\n    .adsList {\n        grid-template-columns: repeat(6, 1fr);\n    }\n}\n\n@media (min-width: 1700px) {\n    .adsList {\n        grid-template-columns: repeat(7, 1fr);\n    }\n}\n\n@media (min-width: 1920px) {\n    .adsList {\n        grid-template-columns: repeat(8, 1fr);\n    }\n}\n\n@media (min-width: 2560px) {\n    .adsList {\n        grid-template-columns: repeat(9, 1fr);\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
